module.exports = __webpack_public_path__ + "img/integrations-magento.3ec6a102.png";